var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--jawn"},[_c('div',{staticClass:"spinner-inner",style:(_vm.styles)},[_c('div',{staticClass:"jawn",style:(_vm.innerStyles)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }